
$(document).ready(function(){
  var ColorLen = $(".ColorContainer label").length;
  var SizeLen = $(".SizeContainer label").length;
  setTimeout(function(){ 
  if(SizeLen == 1 || ColorLen == 1){
   
  $(".SizeContainer label:nth-of-type(1)").trigger( "click" );
  }
     }, 100);
  var getlength = $("#shopify-section-collection-template .productList .grid__item").length;
  if(getlength == 0){
  $(".filters-toolbar__item--count").hide();
    $(".filterBox ul").hide();
    $(".CustomProductCount").show();
  }
  else{
   $(".filters-toolbar__item--count").show();
    $(".filterBox ul").show();
    $(".CustomProductCount").hide();
  }
  $(".product-form__cart-submit").click(function(i) {
    if (i.preventDefault(), "disabled" != $(this).attr("disabled"))
      if (theme.ajax_cart) {
        setTimeout(function() { console.log('reinit'); CartJS.getCart(); }, 2000);
      }
  });


  $(".ColorContainer label.ColorVar").each(function(){
   var imagePath ;
    var $this = $(this);
  var gettitle = $(this).attr("title");
    $(".SizeMatch").each(function(){
    var ColorName = $(this).text();
      if(ColorName == gettitle)
      {
      var getimageurl = $(this).attr("data-image");
        $this.css("background-image","url("+getimageurl+")");
      }
    })
   })
  
  
  
    $('body').on('click', '.SizeContainer .SizeVar', function() {
      $('#AddToCart-product-template').prop("disabled", false);
      $(".ColorVar.shownow.checked").removeClass("checked");
    var size = $(this).html();
      $(".SizeContainer .headerVar .slVariant").html(size);
      size = $.trim(size);
      setTimeout(function(){ 
      var selectedColor = $(".ColorVar.active").attr("title");
      selectedColor = $.trim(selectedColor);
      var mergeValue = size+" / "+selectedColor
       $(".SizeMatch").each(function(){
         
       var completevar = $(this).attr("data-complete");
          if(completevar==mergeValue){
            var idGet = $(this).attr("data-id");
          var SavePrice = $(this).attr("data-save");
            var SavePercentage = $(this).attr("data-per");
            var Price = $(this).attr("data-price");
             var CompPrice = $(this).attr("data-comp");
            var SKU = $(this).attr("data-sku");
            $("#ComparePrice-product-template").html(CompPrice);
            $("#ProductPrice-product-template").html(Price);
             $("#SaveAmount-product-template").html(SavePrice);
            $(".off span").html(SavePercentage);
             $(".variant-sku").html(SKU);
             //console.log(idGet);
            $(".idmeasure").html(idGet);
           
          }
        })
         }, 200);
    $(".SizeContainer label.SizeVar").each(function(){
                                        $(this).removeClass("active");     
                                             })
     $(this).addClass("active"); 
     
       $(".SizeMatch").each(function(){
    var Datatitle = $(this).attr("data-title");
    Datatitle = $.trim(Datatitle);
      if(Datatitle == size){
      var colorName = $(this).html();
        colorName = $.trim(colorName);
        $(".ColorVar").each(function(){
    var color = $(this).attr("title");
      color = $.trim(color);
     
      if(color == colorName){
     $(this).addClass("shownow");
     $(this).addClass("checked");
      
      }
          else{
            if($(this).hasClass("checked")){}
            else{
            $(this).removeClass("shownow");
            }
          }
      
          
    })
     
      }
    })
       setTimeout(function(){ 
       if($(".ColorVar.active").hasClass("shownow")){
       //console.log("HAi");
         
       }
      else{
        console.log("Nahi HAi");
        $(".ColorVar.active").removeClass("active");
        $(".ColorVar.shownow").each(function(index){
          if(index == 0){
          $(this).addClass("active");
           
            //$(".ColorVar.shownow.checked.active").trigger("click");
            var titleGet = $(this).attr("title");
            $(".ColorContainer .headervar .slVariant").html(titleGet);
            $(".ColorVar.shownow.checked.active").trigger("click");
          }
        })
      } 
          }, 100);
  })
    
      $('body').on('click', '.ColorContainer .ColorVar', function() {
        $(".SizeVar").removeClass("afteradding")
    var color = $(this).attr("title");
        $(".ColorContainer .headervar .slVariant").html(color);
      color = $.trim(color);
        console.log(color);
        $(".SizeMatch").each(function(){
        var newValye = $(this).attr("data-complete");
          newValye = newValye.split("/");
          var firstsizehalf = newValye[0];
            firstsizehalf = $.trim(firstsizehalf);
          var secondcolorhalf = newValye[1];
          secondcolorhalf = $.trim(secondcolorhalf);
          if(color == secondcolorhalf){
          
            $(".SizeVar").each(function(){
              var TitleHalf = $(this).attr("title");
              if(TitleHalf == firstsizehalf){
             $(this).addClass("SizeShowing");
                $(this).removeClass("Sizehide");
               $(this).addClass("afteradding");
                
              }
              else{
                if($(this).hasClass("afteradding")){}
                else{
                $(this).removeClass("SizeShowing");
                  $(this).addClass("Sizehide");
                }
              }
            })
          }
          
        })
        if($(".SizeVar").hasClass("active")){
         var selectedSize = $(".SizeVar.active").attr("title");
        }
        else{
        var selectedSize = $(".SizeVar.Newactive").attr("title");
        }
       
        selectedSize = $.trim(selectedSize);
        var mergeValue = selectedSize+" / "+color;
        
        $(".SizeMatch").each(function(){
        var oldcompletevar = $(this).attr("data-complete");
       var Newcompletevar =     oldcompletevar.split("/");
       Newcompletevar = $.trim(Newcompletevar[1]);
            if(Newcompletevar==color){
              console.log(color);
              var idGet = $(this).attr("data-id");
           var imgSrc = $(this).attr("data-image");
            $(".product-single__thumbnails-item").each(function(){
            var LinkSrc = $(this).children(".product-single__thumbnail").attr("href");
             
              if(LinkSrc == imgSrc){
               console.log(LinkSrc+""+ imgSrc);
              var IndexNum = $(this).attr("data-slick-index");
                $('.product-single__thumbnails').slick('slickGoTo', IndexNum);
                $(this).addClass("clickable");
                $(".clickable").trigger("click");
               // $( '.product-single__thumbnails' ).slickGoTo(IndexNum);
                //$('.primgSlider').slick('slickGoTo', IndexNum);
                //console.log(IndexNum);
               // $('.product-single__thumbnails').slickGoTo(IndexNum);
              }
            })
              return false;
            }
        })
                             
                             
        $(".SizeMatch").each(function(){
       var completevar = $(this).attr("data-complete");
      
          if(completevar==mergeValue){
           
           var idGet = $(this).attr("data-id");
           var imgSrc = $(this).attr("data-image");
            $(".product-single__thumbnails-item").each(function(){
            var LinkSrc = $(this).children(".product-single__thumbnail").attr("href");
             
              if(LinkSrc == imgSrc){
               console.log(LinkSrc+""+ imgSrc);
              var IndexNum = $(this).attr("data-slick-index");
                $('.product-single__thumbnails').slick('slickGoTo', IndexNum);
                $(this).addClass("clickable");
                $(".clickable").trigger("click");
               // $( '.product-single__thumbnails' ).slickGoTo(IndexNum);
                //$('.primgSlider').slick('slickGoTo', IndexNum);
                //console.log(IndexNum);
               // $('.product-single__thumbnails').slickGoTo(IndexNum);
              }
            })
            //console.log(idGet);
            $(".idmeasure").html(idGet);
          var SavePrice = $(this).attr("data-save");
            var SavePercentage = $(this).attr("data-per");
            var Price = $(this).attr("data-price");
             var CompPrice = $(this).attr("data-comp");
            var SKU = $(this).attr("data-sku");
            $("#ComparePrice-product-template").html(CompPrice);
            $("#ProductPrice-product-template").html(Price);
             $("#SaveAmount-product-template").html(SavePrice);
            $(".off span").html(SavePercentage);
             $(".variant-sku").html(SKU);
           
          }
        })
    $(".ColorContainer label.ColorVar ").each(function(){
                                        $(this).removeClass("active");     
                                             })
     $(this).addClass("active"); 
      })
//       $(".custom_link").each(function(index){
      
//        var geturl =  $(this).children("a").attr("href");
//          var title =  $(this).children("a").attr("title");
//         $.ajax({
//           type: "GET",
//           url: geturl,
//           async:"false",
//           datatype: "html",
//           success: function(data){
//           var length = $(data).find(".productList .grid__item").length;
//             if(length == 0)
//             {
//             console.log(title+"::::"+length);
//               $(this).hide();
//               $(this).css("display","none !important");
//             }
//           }
//         })
        
//       })
})